import { useEffect } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryList, getGiftCategoryList } from "../slice/categorySlice";

const useGiftCategoryList = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.app.curretDropdownData);
  const getAllGiftCategoryList = async () => {
    const param = {
      zone_id: Data?.zone_id,
    }
    const response = await Axios.post("/gift_category_list", param);
    const data = await response.data;
    dispatch(getGiftCategoryList(data.giftCategoryList));
  };
  useEffect(() => {
    getAllGiftCategoryList();
  }, [Data?.zone_id]);

  return getAllGiftCategoryList;
};

export default useGiftCategoryList;
